<template>
	<div class="idT">
		<van-image fit="contain" width="100" :src="config.logo" @click="$router.push('/mobile/home')" />
		<div class="content">
			<div class="dl" @click="$router.push('/mobile/login')" v-if="!token">
				{{ $t('登陆') }}
			</div>
			<van-icon name="service" size="22" @click="kefuCk" />
			<!-- <van-icon name="bell" size="20" />
            <van-icon name="point-gift" size="20" /> -->
			<van-icon name="bars" size="26" @click="popUp = true" />
		</div>

		<van-popup v-model="popUp" position="left" closeable class="popUp">
			<div class="popContent">
				<div class="srHead">
					<div class="dls" @click="login" v-if="!token">{{ $t('登陆') }}</div>
					<div class="zc" @click="register" v-if="!token">{{ $t('注册') }}</div>
					<van-image fit="contain" width="100" :src="config.logo" />
				</div>
				<div v-if="token" class="userIn">
					<div>{{ userinfo.nickname }}</div>
					<div style="padding-left: 20px;">{{ $t('信用分') }}：</div>
					<div>{{ userinfo.credit_score }}</div>
				</div>

				<!-- <div class="certification" v-if="token">
                    <div class="titleA">
                        <van-icon name="warning" />
                        <div class="titleB">{{ $t('请尽快完成实名认证') }}</div>
                    </div>
                    <div @click="certification">
                        {{ $t('去认证') }}
                    </div>
                </div> -->

				<div v-for="(item, index) in titletList" :key="'a' + index">
					<div class="title">
						<div class="titleA" @click="jump(index)">
							<van-icon :name="item.icon" />
							<div class="titleB">{{ item.title }}</div>
						</div>
						<div v-if="index == 3" @click="jump(index)" style="display: flex;align-items: center;">
							<div style="margin-right: 10px;">{{ langObj.name }}</div>
							<van-image width="30" :src="langObj.icon" fit="contain" />
						</div>
						<div v-if="item.key && item.key1" style="display: flex;align-items: center;">
							<div style="margin-right: 10px;" :class="[userinfo[item.key1] == item.key2? 'green' : 'red' ]">{{ userinfo[item.key] }}</div>
						</div>
						<!-- <van-icon :name="item.img" v-if="index == 3" /> -->
					</div>
					<div v-if="index == 5 && tradingCenter" class="tradingCenter">
						<div v-for="(item, index) in tradeList" :key="index" class="trading" @click="tradeC(index)">
							{{ item.title }}
						</div>
					</div>
				</div>

				<div>
					<div class="title" @click="go('/mobile/resetPwd')">
						<div class="titleA">
							<van-icon name="warning" />
							<div class="titleB">{{ $t('重置密码') }}</div>
						</div>
					</div>
				</div>
				<div class="quit" @click="quit" v-if="token">
					<div class="item">{{ $t('退出登陆') }}</div>
				</div>
			</div>
		</van-popup>

		<van-popup v-model="country" position="left" closeable class="popUp">
			<div class="popContent">
				<div class="srHead">
					{{ $t('语言') }}
				</div>
				<div class="title" v-for="item in langList" :key="item.id">
					<div class="titleA" @click="language(item)">
						<van-image width="30" :src="item.icon" fit="contain" />
						<div class="titleB">{{ item.name }}</div>
					</div>
				</div>
			</div>
		</van-popup>

	</div>
</template>

<script>
	import { get,  } from '@/http/request'
	import i18n from '@/i18n'
	import {
		openKefu
	} from '@/common/public.js'
	import {
		Toast
	} from 'vant';
	import {
		mapState
	} from "vuex";
	export default {

		data() {
			return {
				popUp: false,
				country: false,
				tradingCenter: false,
				finance: false,
				langObj: {},
				tradeList: [{
						title: this.$t('期权'),
						url: '/mobile/trade'
					},
					{
						title: this.$t('现货'),
						url: `/mobile/trade?id=1`
					},
					{
						title: this.$t('合约'),
						url: `/mobile/trade?id=2`
					},
					// {
					//     title: "C2C",
					//     url: '1123'
					// },
					// {
					//     title: "模拟交易",
					//     url: '1123'
					// }
				],
				titletList: [{
						title: this.$t('首页'),
						icon: require('@/assets/img/icon/icon1.png'),
						url: '/mobile/home'
					},

					{
						title: this.$t('提币'),
						icon: require('@/assets/img/icon/icon2.png'),
						url: '/mobile/extract'
					},
					{
						title: this.$t('充值'),
						icon: require('@/assets/img/icon/icon2.png'),
						url: '/mobile/topUp'
					},
					{
						title: this.$t('语言'),
						icon: require('@/assets/img/icon/icon3.png'),
						url: '',
						img: require('@/assets/img/countryIcon/CN.png')
					},
					{
						title: this.$t('AI策略交易'),
						icon: require('@/assets/img/icon/icon4.png'),
						url: '/mobile/aiTrade'
					},
					{
						title: this.$t('交易中心'),
						icon: require('@/assets/img/icon/icon5.png'),
						url: '',
						img: 'play'
					},

					{
						title: this.$t('资产中心'),
						icon: require('@/assets/img/icon/icon6.png'),
						url: '/mobile/mine'
					},
					{
						title: this.$t('身份认证'),
						icon: 'warning',
						url: '/mobile/certification',
						key: 'real_status_text',
						key1: 'real_status',
						key2: 1,
					},
					{
						icon: 'point-gift',
						title: this.$t('分享好友'),
						url: '/mobile/invitation'
					},
					{
						icon: 'cluster',
						title: this.$t('投资组合'),
						url: '/mobile/service'
					},
					{
						icon: 'bookmark',
						title: this.$t('行情'),
						url: '/mobile/quotes'
					},
					// {
					//     title: "NFT",
					//     icon: 'wap-home',
					//     url: '258'
					// },
					// {
					//     title: "金融理财",
					//     icon: 'wap-home',
					//     url: '258',
					//     img: 'play'
					// },
				]

			};
		},
		computed: {
			...mapState(["config"]),
			langList() {
				console.log(this.config.langList, 'config');
				return this.config.langList
			},
			userinfo() {
				console.log(this.$store.getters.getUserInfo, '3')
				return this.$store.getters.getUserInfo
			},
			token() {
				console.log(this.$store.getters.getToken, '2');
				return this.$store.getters.getToken
			},

		},
		mounted() {
			this.getUserInfo()
		},
		created() {},
		watch: {
			config(newVal) {
				if (newVal && Object.keys(newVal).length > 0) {
					this.langObj = newVal.langList.find(item => item.value === localStorage.getItem('defaultLang'))
				}
			}
		},

		methods: {
			kefuCk() {
				openKefu()
			},
			certification() {
				this.$router.push('/mobile/certification')
				this.popUp = false
			},
			//弹框点击选项
			jump(index) {
				console.log(index);
				if (index == 3) {
					this.country = true
					return
				}
				if (index == 5) {
					this.tradingCenter = !this.tradingCenter
					return
				}
				// if (index == 8) {
				//     this.finance = !this.finance
				//     return
				// }
				this.$router.push(`${this.titletList[index].url}`)
				this.popUp = false
			},
			go(url) {
				if (url) {
					this.$router.push(url)
					this.popUp = false
				}
			},
			//交易中心
			tradeC(index) {
				this.$router.push(`${this.tradeList[index].url}`)
				this.popUp = false
			},
			//语言
			language(item) {
				console.log(item.value);

				// 1️⃣ 显示 loading 动画
				Toast.loading({
					duration: 0, // 一直显示，不会自动关闭
					forbidClick: true,
					overlay: true, // 带半透明遮罩
				});

				i18n.locale = item.value
				this.$store.commit('setDefaultLang', item.value)
				this.langObj = item
				this.country = false
				this.$router.go(0);

			},
			async getUserInfo() {
				const res = await get(this.$apis.getUserInfo)
				if (res.code == 1) {
					this.$store.commit('setUserInfo', res.data)
					return
				}
			},
			login() {
				this.popUp = false
				this.$router.push('/mobile/login')
			},
			register() {
				this.popUp = false
				this.$router.push('/mobile/register')
			},
			//退出登陆
			quit() {
				this.popUp = false
				this.$store.commit('setUserInfo', '')
				this.$store.commit('setToken', '')
				this.$router.push('/mobile/login')
			}

		},
	};
</script>

<style lang="less" scoped>
	.idT {
		background-color: #000 !important;
		padding: 10px;
		display: flex;
		color: #fff;
		justify-content: space-between;
		align-items: center;
		z-index: 999;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;


		.popUp {
			width: 100%;
			height: 100%;
			background-color: #000;

			.popContent {
				padding: 20px;
				//position: relative;
				height: 100dvh;
				overflow-y: auto;
				scrollbar-width: none;
				-ms-overflow-style: none;

				.quit {
					background-color: #000;
					color: #000;
					width: 100%;

					.item {
						position: relative;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						width: 70%;
						background-color: #00f0ff;
						border-radius: 5px;
						text-align: center;
						padding: 10px 0;
						margin: 20px 0;

					}
				}

				.tradingCenter {
					color: #999;
					font-size: 14px;
					padding-left: 26px;

					.trading {
						padding-top: 10px;
						padding-bottom: 20px;
					}
				}

				.title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 18px 0;

					.titleA {
						display: flex;
						align-items: center;

						.titleB {
							padding-left: 10px;
						}
					}
					
					.green{
						color: green;
					}
					
					.red{
						color: red;
					}
				}

				.certification {
					border-radius: 5px;
					background: linear-gradient(90deg, rgba(219, 66, 66, .5) 0%, rgba(117, 35, 35, .095) 100%);
					padding: 10px;
					display: flex;
					align-items: center;
					margin-top: 20px;
					margin-bottom: 10px;
					justify-content: space-between;
					font-size: 14px;

					.titleA {
						display: flex;
						align-items: center;

						.titleB {
							padding-left: 10px;
						}
					}
				}

				.srHead {
					display: flex;
					padding-bottom: 16px;
					font-size: 14px;

					.dls {
						background: #00f0ff;
						border-radius: 4px;
						padding: 8px 16px;
					}

					.zc {
						background: #1f2e38;
						border-radius: 4px;
						padding: 8px 16px;
						margin: 0 20px;
					}
				}

				.userIn {
					display: flex;
					align-items: flex-end;
					padding-bottom: 10px;
				}
			}
		}


		.content {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.van-icon {
				padding-left: 20px;
			}

			.dl {
				border: 1px solid #fff;
				padding: 6px 18px;
				border-radius: 30px;
				font-size: 12px;
			}
		}

	}
</style>